// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8 8.00003L8 11.0001H9.5C10.3284 11.0001 11 10.3285 11 9.50003C11 8.67157 10.3284 7.99998 9.49997 8L8 8.00003Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM8 13.0001L8 18H6V6.00007L9.49993 6C11.433 5.99996 13 7.56702 13 9.50003C13 11.433 11.433 13.0001 9.5 13.0001H8ZM13.5 12.4528C13.5 11.0982 14.5982 10 15.9528 10H18V12H15.9528C15.7027 12 15.5 12.2027 15.5 12.4528C15.5 12.6478 15.6247 12.8208 15.8096 12.8825L16.8228 13.2202C17.8244 13.554 18.5 14.4914 18.5 15.5472C18.5 16.9018 17.4018 18 16.0472 18H13.5V16H16.0472C16.2973 16 16.5 15.7973 16.5 15.5472C16.5 15.3522 16.3753 15.1792 16.1904 15.1175L15.1772 14.7798C14.1756 14.446 13.5 13.5086 13.5 12.4528Z"}}]};

const LogoAdobePhotoshopFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-adobe-photoshop-filled',
    ref,
    icon: element,
  },
));

LogoAdobePhotoshopFilledIcon.displayName = 'LogoAdobePhotoshopFilledIcon';

export default LogoAdobePhotoshopFilledIcon;
